<template>
  <div class="progress">
    <div class="progress-core-container">
      <div class="progress-core" :style="getStyle">
        <div class="progress-bar"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: Number,
    current: Number
  },
  computed: {
    getStyle () {
      return {
        width: `${this.total && this.current ? Math.min(this.current / this.total * 100, 100) : 0}%`
      }
    }
    // getBarStyle () {
    //   return {
    //     left: `${this.total && this.current ? Math.min((this.current - 5) / this.total * 100, 96) : 0}%`
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  position: relative;
  @include px2res(width, 348);
  @include px2res(height, 26);
  overflow: hidden;

  .progress-core-container {
    position: absolute;
    @include px2res(left, 8);
    top: 50%;
    transform: translateY(-50%);
    @include px2res(width, 332);
    @include px2res(height, 14);

    .progress-core {
      position: relative;
      @include px2res(height, 14);
      @include px2res(border-radius, 7);
      background-color: #F5C322;
      transition: width 0.5s cubic-bezier(0.45, 0, 0.55, 1);

      .progress-bar {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        @include px2res(right, -5);
        @include px2res(width, 14);
        @include px2res(height, 26);
        transition: left 0.5s cubic-bezier(0.45, 0, 0.55, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shop/progress.vue